<template>


    <div ref="floatDrag" class="float-position" :style="{ left: left + 'px', top: top + 'px', zIndex: zIndex }"
        @touchmove.prevent @mousemove.prevent @mousedown="mouseDown" @mouseup="mouseUp">
        <el-badge :value="MsgArrayTotal.totalMsg" class="item">
            <svg t="1699855525737" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="15157" width="40" height="40">
                <path
                    d="M311.8 169.2L253.6 111C156.4 185.1 92.1 300.2 86 430.4h81.4c6.1-107.8 61.4-202.2 144.4-261.2z m544.8 261.2H938C931.9 300.2 867.6 185 770 111l-58.2 58.2c83.4 59 138.7 153.4 144.8 261.2z m-80.1 20.4c0-124.9-86.7-229.5-203.4-257.1V166c0-33.8-27.3-61-61-61-33.8 0-61 27.3-61 61v27.7c-116.8 27.7-203.4 132.2-203.4 257.1v223.8L166.3 756v40.7H858V756l-81.4-81.4V450.8zM512 918.7c5.7 0 11-0.4 16.3-1.6 26.4-5.3 48.4-23.6 58.6-48 4.1-9.8 6.5-20.3 6.5-31.7H430.6c0 44.7 36.6 81.3 81.4 81.3z m0 0"
                    fill="#1296db" p-id="15158"></path>
            </svg>
        </el-badge>
    </div>



</template>

<script>
    export default {
        name: "DragBall",
        props: {
            distanceRight: {
                type: Number,
                default: 0
            },
            distanceBottom: {
                type: Number,
                default: 100
            },
            isScrollHidden: {
                type: Boolean,
                default: false
            },
            isCanDraggable: {
                type: Boolean,
                default: true
            },
            zIndex: {
                type: Number,
                default: 50
            },
            value: {
                type: String,
                default: "悬浮球！"
            },
            msgTotal: {
                type: Number,
                default: 0
            },
        },

        //data 域
        data() {
            return {
                clientWidth: null,
                clientHeight: null,
                left: 0,
                top: 0,
                timer: null,
                currentTop: 0,
                mousedownX: 0,
                mousedownY: 0,
                MsgArrayTotal: {
                    totalMsg: 0,
                    OrdinaryMsgTotal: 0,
                    ForceMsgTotal: 0,
                    NoticeMsgTotal: 0,
                },
            };
        },
        created() {
            this.loader()
            this.clientWidth = document.documentElement.clientWidth;
            this.clientHeight = document.documentElement.clientHeight;
        },
        mounted() {
            this.isCanDraggable &&
                this.$nextTick(() => {
                    this.floatDrag = this.$refs.floatDrag;
                    // 获取元素位置属性
                    this.floatDragDom = this.floatDrag.getBoundingClientRect();
                    // 设置初始位置
                    this.left =
                        this.clientWidth - this.floatDragDom.width - this.distanceRight;
                    this.top =
                        this.clientHeight - this.floatDragDom.height - this.distanceBottom;
                    this.initDraggable();
                });
            this.isScrollHidden && window.addEventListener("scroll", this.handleScroll);
            window.addEventListener("resize", this.handleResize);
        },
        methods: {
            /**
             * 设置滚动监听
             * 设置滚动时隐藏悬浮按钮，停止时显示
             */
            loader() {
                if (JSON.parse(window.localStorage.getItem('MsgArrayTotal'))) {
                    this.MsgArrayTotal = JSON.parse(window.localStorage.getItem('MsgArrayTotal'))
                }

            },
            handleScroll() {
                this.timer && clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.handleScrollEnd();
                }, 200);
                this.currentTop =
                    document.documentElement.scrollTop || document.body.scrollTop;
                if (this.left > this.clientWidth / 2) {
                    // 判断元素位置再左侧还是右侧
                    this.left = this.clientWidth + this.floatDragDom.width;
                } else {
                    this.left = -this.floatDragDom.width;
                }
            },
            /**
             * 滚动结束
             */
            handleScrollEnd() {
                let scrollTop =
                    document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop === this.currentTop) {
                    console.log(this.left);
                    if (this.left > this.clientWidth / 2) {
                        // 判断元素位置再左侧还是右侧
                        this.left = this.clientWidth - this.floatDragDom.width;
                    } else {
                        this.left = 0;
                    }
                    clearTimeout(this.timer);
                }
            },
            /**
             * 窗口resize监听
             */
            handleResize() {
                this.clientWidth = document.documentElement.clientWidth;
                this.clientHeight = document.documentElement.clientHeight;
                this.checkDraggablePosition();
            },
            /**
             * 初始化draggable
             */
            initDraggable() {
                this.floatDrag.addEventListener("touchstart", this.toucheStart);
                this.floatDrag.addEventListener("touchmove", e => this.touchMove(e));
                this.floatDrag.addEventListener("touchend", this.touchEnd);
            },
            mouseDown(e) {
                const event = e || window.event;
                this.mousedownX = event.screenX;
                this.mousedownY = event.screenY;
                const that = this;
                let floatDragWidth = this.floatDragDom.width / 2;
                let floatDragHeight = this.floatDragDom.height / 2;
                if (event.preventDefault) {
                    event.preventDefault();
                }
                this.canClick = false;
                this.floatDrag.style.transition = "none";
                document.onmousemove = function (e) {
                    var event = e || window.event;
                    that.left = event.clientX - floatDragWidth;
                    that.top = event.clientY - floatDragHeight;
                    if (that.left < 0) that.left = 0;
                    if (that.top < 0) that.top = 0;
                    if (that.left >= that.clientWidth - floatDragWidth * 2) {
                        that.left = that.clientWidth - floatDragWidth * 2;
                    }
                    if (that.top >= that.clientHeight - floatDragHeight * 2) {
                        that.top = that.clientHeight - floatDragHeight * 2;
                    }
                };
            },
            mouseUp(e) {
                const event = e || window.event;
                //判断只是单纯的点击，没有拖拽
                if (
                    this.mousedownY == event.screenY &&
                    this.mousedownX == event.screenX
                ) {
                    this.$emit("handlepaly");
                }
                document.onmousemove = null;
                this.checkDraggablePosition();
                this.floatDrag.style.transition = "all 0.3s";
            },
            toucheStart() {
                this.canClick = false;
                this.floatDrag.style.transition = "none";
            },
            touchMove(e) {
                this.canClick = true;
                if (e.targetTouches.length === 1) {
                    // 单指拖动
                    let touch = event.targetTouches[0];
                    this.left = touch.clientX - this.floatDragDom.width / 2;
                    this.top = touch.clientY - this.floatDragDom.height / 2;
                }
            },
            touchEnd() {
                if (!this.canClick) return; // 解决点击事件和touch事件冲突的问题
                this.floatDrag.style.transition = "all 0.3s";
                this.checkDraggablePosition();
            },
            /**
             * 判断元素显示位置
             * 在窗口改变和move end时调用
             */
            checkDraggablePosition() {
                if (this.left + this.floatDragDom.width / 2 >= this.clientWidth / 2) {
                    // 判断位置是往左往右滑动
                    this.left = this.clientWidth - this.floatDragDom.width;
                } else {
                    this.left = 0;
                }
                if (this.top < 0) {
                    // 判断是否超出屏幕上沿
                    this.top = 0;
                }
                if (this.top + this.floatDragDom.height >= this.clientHeight) {
                    // 判断是否超出屏幕下沿
                    this.top = this.clientHeight - this.floatDragDom.height;
                }
            }
        },
        beforeDestroy() {
            window.removeEventListener("scroll", this.handleScroll);
            window.removeEventListener("resize", this.handleResize);
        }
    };
</script>
<style>
    html,
    body {
        overflow: hidden;
    }
</style>
<style scoped lang="less">
    .float-position {
        position: absolute;
        z-index: 99999 !important;
        right: 0px;
        top: 70%;
        width: 73px;
        height: 90px;
        /* background: #fff; */
        border-radius: 50%;
        overflow: hidden;
        /* box-shadow: 0px 0px 10px 2px skyblue; */
        /* border: 1px solid skyblue; */
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.8em;
        user-select: none;

    }


    .float-position:hover {
        transition: all 0.5s;
        /* box-shadow: 2px 2px 2px 2px skyblue;
        background: skyblue; */
        /* width: 80px;
        height: 80px; */
    }

    .cart {
        border-radius: 50%;
        width: 5em;
        height: 5em;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .header-notice {
        display: inline-block;
        transition: all 0.3s;

        span {
            vertical-align: initial;
        }

        .notice-badge {
            color: inherit;

            .header-notice-icon {
                font-size: 16px;
                padding: 4px;
            }
        }
    }

    .drag-ball .drag-content {
        overflow-wrap: break-word;
        font-size: 14px;
        color: #fff;
        letter-spacing: 2px;
    }

    .item {
        /* position: absolute; */
        /* margin-top: 10px; */
        /* margin-right: 40px; */
        /* margin-top: -10px; */

    }


    /deep/ .el-badge__content.is-fixed {
        position: absolute;
        top: 8px;
        right: 20px;
        transform: translateY(-50%) translateX(100%);
    }
</style>